import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IBank } from 'app/shared/model/bank.model';
import { getEntities as getBanks } from 'app/entities/bank/bank.reducer';
import { getEntity, updateEntity, createEntity, reset } from './commission-log.reducer';
import { ICommissionLog } from 'app/shared/model/commission-log.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const CommissionLogUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const banks = useAppSelector(state => state.bank.entities);
  const commissionLogEntity = useAppSelector(state => state.commissionLog.entity);
  const loading = useAppSelector(state => state.commissionLog.loading);
  const updating = useAppSelector(state => state.commissionLog.updating);
  const updateSuccess = useAppSelector(state => state.commissionLog.updateSuccess);
  const handleClose = () => {
    props.history.push('/commission-log' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getBanks({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...commissionLogEntity,
      ...values,
      bank: banks.find(it => it.id.toString() === values.bank.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...commissionLogEntity,
          bank: commissionLogEntity?.bank?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="comexApp.commissionLog.home.createOrEditLabel" data-cy="CommissionLogCreateUpdateHeading">
            <Translate contentKey="comexApp.commissionLog.home.createOrEditLabel">Create or edit a CommissionLog</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="commission-log-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('comexApp.commissionLog.commission')}
                id="commission-log-commission"
                name="commission"
                data-cy="commission"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('comexApp.commissionLog.commissionAmount')}
                id="commission-log-commissionAmount"
                name="commissionAmount"
                data-cy="commissionAmount"
                type="text"
              />
              <ValidatedField
                label={translate('comexApp.commissionLog.commissionForEachAmount')}
                id="commission-log-commissionForEachAmount"
                name="commissionForEachAmount"
                data-cy="commissionForEachAmount"
                type="text"
              />
              <ValidatedField
                id="commission-log-bank"
                name="bank"
                data-cy="bank"
                label={translate('comexApp.commissionLog.bank')}
                type="select"
              >
                <option value="" key="0" />
                {banks
                  ? banks.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/commission-log" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CommissionLogUpdate;
